export default __webpack_public_path__ + "static/media/moovelabel.52ce977c.svg";